/**
 * English catalogue for namespace 'state' (W1-09 state-store): reasons and labels produced by the DocStore
 * (src/state/docStore.ts, gesture.ts, history.ts). Imports only src/i18n/define.ts (catalogue zone, ARCHITECTURE.md §4).
 *
 * Invariant violations are reported with the violation's own catalogue key (namespace 'model', CR-W1-03-2), so they
 * are not repeated here.
 */

import { catalogOf, defineMessages } from '../i18n/define';

export const m = defineMessages('state', {
  /** A transaction was started while a live gesture (drag, scrub, generator preview) is in progress. */
  gestureActive: 'Finish or cancel the current drag first.',
  /** `update` on a gesture that was already committed, cancelled or superseded. */
  gestureEnded: 'This drag has already ended.',
  /** Label of the history marker written when the undo history is cleared. */
  historyCleared: 'History cleared',
  /** Notice when the memory cap dropped the oldest undo steps. */
  historyDropped:
    '{count, plural, one {The oldest undo step was} other {The # oldest undo steps were}} removed to stay within the memory limit. Versions still have them.',
  /** Undo or redo could not be applied to the current document (the history no longer matches it). */
  historyStale:
    'Undo is not possible here: the history no longer matches the project. The history was cleared; Versions still have earlier states.',
  /** Undo was refused because it would have broken the chart in a new way (the reason follows separately). */
  undoRefused: 'This step cannot be undone without breaking the chart. Nothing was changed and the history was kept.',
  /** Redo was refused because it would have broken the chart in a new way (the reason follows separately). */
  redoRefused: 'This step cannot be redone without breaking the chart. Nothing was changed and the history was kept.',
  /** Fallback reason when a transaction broke an invariant that has no catalogue message. */
  txnRejected:
    'The change was not applied because it would break the chart ({count, plural, one {# problem} other {# problems}}).',
});

export default catalogOf(m);
